import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import loadOrderByOrderNumber from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

interface OrderParameter {
    orderNumber: string;
    orderDate?: string;
    // isLoading: boolean;
    onSuccess?: () => void;
    expand?: ("orderLines" | "shipments" | "vmidetails")[];
}

export interface OrderResult {
    order: OrderModel;
}

type HandlerType = ApiHandlerDiscreteParameter<OrderParameter,  
{ orderNumber: string; orderDate?: string; expand?: ("orderLines" | "shipments" | "vmidetails")[]},
GetOrderApiParameter, OrderModel>;

export const DispatchSetOrderNumber: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderDetails/SetOrderNumber",
        orderNumber: props.parameter.orderNumber,
    });
};

export const DispatchLoadOrderIfNeeded: HandlerType = props => {
    // const orderState = getOrderState(props.getState(), props.parameter.orderNumber);
    // if ((!orderState.value && !orderState.isLoading) || !orderState.value.orderLines) {
        props.dispatch(loadOrderByOrderNumber(props.parameter));
    // }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
    const isLoading = false;
};

export const chain = [DispatchSetOrderNumber, DispatchLoadOrderIfNeeded, ExecuteOnSuccessCallback];

const displayOrder = createHandlerChainRunner(chain, "DisplayOrder");
export default displayOrder;
